import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RestrictionComponent } from './restriction/restriction.component';
import { SharedModule } from '../shared.module';
import { CustomFlexLayoutModule } from '../flex-layout/custom-flex-layout.module';

@NgModule({
  declarations: [
    RestrictionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CustomFlexLayoutModule
  ], exports: [
    RestrictionComponent
  ]
})
export class RestrictionPopUpModule { }
